import { Avatar } from "@mui/material";
import React, { useState } from "react";
import { optionsBranch } from "../data/branch-data";
import { convertDateToString, matchOptions } from "../utils/function";
import ModalView from "./ModalView";
import _ from "lodash";
import { generateStatus } from "../utils/generateDisplay";
import { internType } from "../data/interntype-data";

const InternPersonsQty = ({ companyDetail }) => {
  const [isModaOpen, setIsModalOpen] = useState(false);

  if (!companyDetail?.internStudent.length) {
    return;
  }

  const stdGroup = companyDetail?.internStudent?.filter(
    (el) => el.internDetail.status != "0"
  );
  // const stdGroup = companyDetail?.internStudent?.filter(
  //   (el) => el.internDetail.status != "0"
  // );

  const getBranch = stdGroup.map((item) => item.b_id);
  const getUniqBranch = _.uniq(getBranch);

  return (
    <>
      <span
        className="mx-1 badge bg-warning text-dark"
        onClick={() => {
          setIsModalOpen(true);
        }}
        role="button"
      >
        {stdGroup.length} คน
      </span>
      <span
        className="mx-1 badge bg-primary "
        onClick={() => {
          setIsModalOpen(true);
        }}
        role="button"
      >
        {getUniqBranch.length} สาขาวิชา
      </span>

      <ModalView
        title={
          <div className="d-flex gap-1">
            <h3>
              <span className="badge bg-info">{companyDetail.id}</span>
            </h3>
            <div>
              <h3 className="m-0">{companyDetail.name}</h3>
              <small>
                {companyDetail.address} ต.
                {companyDetail.subdistrict} อ.
                {companyDetail.district} จ.
                {companyDetail.province} {companyDetail.zip}
              </small>
            </div>
          </div>
        }
        isModaOpen={isModaOpen}
        setIsModalOpen={setIsModalOpen}
      >
        <div className="p-4">
          <table className="table">
            {/* <thead className="bg-info bg-opacity-25">
              <tr>
                <th scope="col">ชื่อ</th>

                <th scope="col">สาขาวิชา</th>
                <th scope="col">สถานะ</th>
                <th scope="col">เบอร์โทร</th>
              </tr>
            </thead> */}
            <tbody>
              {stdGroup?.map((el) => {
                return (
                  <tr>
                    <td className="d-flex align-items-center">
                      <Avatar
                        key={el.id}
                        alt={el.name}
                        sx={{ height: 50, width: 50 }}
                        src={`http://reg.buu.ac.th/registrar/getstudentimage.asp?id=${el.id}`}
                      />
                      <div>
                        <div className="ms-2">{el.name}</div>
                        <small className="ms-2">{el.id}</small>
                        <small className="ms-2">
                          {matchOptions(optionsBranch, el.b_id)}
                        </small>
                      </div>
                    </td>

                    <td>
                      <div>
                        <span className="badge bg-secondary">
                          {matchOptions(
                            internType,
                            el.internDetail.type_internship
                          )}
                        </span>
                      </div>
                      <small>
                        {convertDateToString(el.internDetail.start_date)} -{" "}
                        {convertDateToString(el.internDetail.end_date)}
                      </small>
                    </td>

                    <td>{generateStatus(el.status_id)}</td>
                    <td>{el.st_tel}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </ModalView>
    </>
  );
};

export default InternPersonsQty;
